<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Gerenciamento de Unidade e Setor</h1>
                                    <p class="modern-subtitle">Gerencie os Unidades e Setores da instituição</p>
                                </div>
                                <div class="tabs-row">
                                    <button class="tab-btn"
                                            :class="{ active: activeTab === 'unidades' }"
                                            @click="setTab('unidades')">
                                        Unidades
                                    </button>
                                    <button class="tab-btn"
                                            :class="{ active: activeTab === 'setores' }"
                                            @click="setTab('setores')">
                                        Setores
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->
                    <div class="container pt-4">
                        <div class="row mb-4" v-if="isLoading">
                            <div class="col-12 text-center my-5">
                                <div class="loading-spinner">
                                    <i class="fas fa-spinner fa-spin fa-3x"></i>
                                    <p class="mt-3">Carregando...</p>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row mb-4 px-4">
                                <div class="col-12 my-3 p-0">
                                    <template v-if="activeTab == 'unidades'">
                                        <div class="modern-table-card">
                                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                <div class="header-group">
                                                    <div class="header-icon">
                                                        <i class="fas fa-building"></i>
                                                    </div>
                                                    <div>
                                                        <span class="header-label">Unidades</span>
                                                        <h4 class="header-title">Unidades da instituição</h4>
                                                    </div>
                                                </div>
                                                <button class="modern-btn modern-btn-primary" @click="novoUnidade()">
                                                    <i class="fas fa-plus me-2"></i>
                                                    Nova Unidade
                                                </button>
                                            </div>

                                            <div class="modern-table-content">
                                                <div v-if="isLoading" class="modern-table-state loading">
                                                    <i class="fas fa-spinner fa-spin"></i>
                                                    <p>Carregando Unidades…</p>
                                                </div>

                                                <div v-else-if="unidades.length === 0" class="modern-table-state empty">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 16 16" fill="currentColor">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h5>Nenhuma unidade cadastrada</h5>
                                                    <p>Registre as unidades da instituição.</p>
                                                </div>

                                                <div v-else class="table-wrapper">
                                                    <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                        <thead>
                                                            <tr>
                                                                <th>Código</th>
                                                                <th>Nome</th>
                                                                <th class="text-center" style="white-space: nowrap; width: 1%;">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in unidades" :key="item.idUnidade">
                                                                <td data-label="Código">
                                                                    <span class="setor-codigo">{{ item.cdUnidade }}</span>
                                                                </td>
                                                                <td data-label="Nome">
                                                                    <span class="setor-nome">{{ item.nmUnidade }}</span>
                                                                </td>
                                                                <td data-label="Ações" class="text-end action-cell">
                                                                    <div class="action-buttons justify-end">
                                                                        <button class="action-btn action-btn-view" @click="editarUnidade(item)" title="Editar">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-9.5 9.5-3.5.5a.5.5 0 0 1-.574-.574l.5-3.5 9.5-9.5zM11.207 2.5 3 10.707V13h2.293L13.5 4.793 11.207 2.5zm1.586-1.586L13 1.707 14.293.414 12.793-.086z" />
                                                                            </svg>
                                                                            <span class="action-text">Editar</span>
                                                                        </button>
                                                                        <button title="Excluir Setor" class="action-btn-delete" @click="excluirUnidade(item)" type="button">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="activeTab == 'setores'">
                                        <div class="modern-table-card">
                                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                <div class="header-group">
                                                    <div class="header-icon">
                                                        <i class="fas fa-building"></i>
                                                    </div>
                                                    <div>
                                                        <span class="header-label">Setor</span>
                                                        <h4 class="header-title">Setores da instituição</h4>
                                                    </div>
                                                </div>
                                                <button class="modern-btn modern-btn-primary" @click="novoSetor()">
                                                    <i class="fas fa-plus me-2"></i>
                                                    Novo Setor
                                                </button>
                                            </div>

                                            <div class="modern-table-content">
                                                <div v-if="isLoading" class="modern-table-state loading">
                                                    <i class="fas fa-spinner fa-spin"></i>
                                                    <p>Carregando setores…</p>
                                                </div>

                                                <div v-else-if="setores.length === 0" class="modern-table-state empty">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 16 16" fill="currentColor">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h5>Nenhum setor cadastrado</h5>
                                                    <p>Registre os setores da instituição.</p>
                                                </div>

                                                <div v-else class="table-wrapper">
                                                    <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                        <thead>
                                                            <tr>
                                                                <th>Código</th>
                                                                <th>Nome</th>
                                                                <th class="text-center" style="white-space: nowrap; width: 1%;">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in setores" :key="item.idPessoa">
                                                                <td data-label="Código">
                                                                    <span class="setor-codigo">{{ item.cdSetor }}</span>
                                                                </td>
                                                                <td data-label="Nome">
                                                                    <span class="setor-nome">{{ item.nmSetor }}</span>
                                                                </td>
                                                                <td data-label="Ações" class="text-end action-cell">
                                                                    <div class="action-buttons justify-end">
                                                                        <button class="action-btn action-btn-view" @click="editarSetor(item)" title="Editar">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-9.5 9.5-3.5.5a.5.5 0 0 1-.574-.574l.5-3.5 9.5-9.5zM11.207 2.5 3 10.707V13h2.293L13.5 4.793 11.207 2.5zm1.586-1.586L13 1.707 14.293.414 12.793-.086z" />
                                                                            </svg>
                                                                            <span class="action-text">Editar</span>
                                                                        </button>
                                                                        <button title="Excluir Setor" class="action-btn-delete" @click="excluirSetor(item)" type="button">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    
                                </div>
                            </div>

                        </div>
                    </div><!-- .container pt-4 -->
                </div><!-- .tyn-section -->
            </div><!-- .tyn-main -->
        </div><!-- .tyn-content -->
        <div class="tyn-footer border-top">
            <div class="bg-white text-center py-3">
                <p class="mb-0 small">
                    &copy; 2025 <a style="color: unset" target="_blank" href="https://sollai.com.br/"> SollAI | Inteligencia Artificial </a>.
                </p>
            </div>
        </div><!-- .tyn-footer -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>
        <ModalCadastroSetor :showModal="showModalSetor" :dados="setorCrud" @reload="() => { load(); }" @close="showModalSetor = false"></ModalCadastroSetor>
        <ModalCadastroUnidade :showModal="showModalUnidade" :dados="unidadeCrud" @reload="() => { load(); }" @close="showModalUnidade = false"></ModalCadastroUnidade>

    </div><!-- .tyn-root -->
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import ModalCadastroSetor from '@/components/Cadastro/ModalCadastroSetor'
    import ModalCadastroUnidade from '@/components/Cadastro/ModalCadastroUnidade'

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import Swal from 'sweetalert2'

    export default {
        name: 'GerenciarSetor',
        components: { Header, Modais, ModalCadastroSetor, ModalCadastroUnidade },
        computed: {
            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },

            isContratoZero() {
                return this.$store.state.user.usuario.idContrato === 0;
            },

            isAdmOuInterno() {
                return this.isAdmContrato == 'Sim' || this.isContratoZero || this.user?.usuarioApi?.flAdministrador;
            },

            currentIdCliente() {
                return this.contrato?.idCliente
                    ?? this.$store.state.user?.usuario?.idCliente
                    ?? (this.isContratoZero ? 0 : null);
            },
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                dados: null,
                isLoading: true,
                showModalSetor: false,
                setores: [],
                setorCrud: null,
                activeTab: 'unidades',

                unidades: [],
                unidadeCrud: null,
            }
        },
        methods: {

            load() {
                let $this = this;
                $this.getSetores();
                $this.getUnidades();
            },

            setTab(tab) {
                this.activeTab = tab
                if (tab === 'unidades' && this.unidades.length === 0) this.getSetores()
                if (tab === 'setores' && this.setores.length === 0) this.getUnidades()

            },

            getSetores() {
                let $this = this;
                $this.isLoading = true;

                axios.get(`${urlApi}/Setor/Get`)
                    .then(res => {
                        if (res.data.success) {
                            $this.isLoading = false;
                            const result = res.data.data;

                            $this.setores = result.rows;

                        } else {
                            avisoErro("Não foi possível carregar os setores.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.status == 403) {
                            avisoErro("Você não tem acesso a esse produto.");
                            setTimeout(() => window.location.href = "/Home", 2000);
                        } else {
                            avisoErro(res.response?.data || res.response?.statusText || "Erro ao carregar");
                        }
                    })
                    .finally(() => {
                        $this.isLoading = false;
                    });
            },

            novoSetor() {
                this.setorCrud = {
                    idSetor: null,
                    nmSetor: null,
                    cdSetor: null,
                    idCliente: this.currentIdCliente,
                };
                this.showModalSetor = !this.showModalSetor;
            },

            editarSetor(setor) {
                this.setorCrud = {
                    idSetor: setor.idSetor,
                    nmSetor: setor.nmSetor,
                    cdSetor: setor.cdSetor,
                    idCliente: this.currentIdCliente,
                };
                this.showModalSetor = !this.showModalSetor;
            },

            excluirSetor(setor) {
                let $this = this;
                Swal.fire({
                    title: 'Confirmar a exclusão do setor "' + setor.nmSetor + '"?',
                    showDenyButton: true,
                    //showCancelButton: true,
                    confirmButtonText: 'Sim',
                    denyButtonText: 'Não',
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/Setor/Delete/`, { idSetor: setor.idSetor })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Setor excluido com sucesso!")
                                    $this.setores = $this.setores.filter(function (elm) { return (elm.idSetor != setor.idSetor) });
                                    $this.getSetores();
                                } else {
                                    avisoErro("Não foi possível excluir o setor.");
                                }

                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.response.data);
                                } else {
                                    avisoErro(res.response.statusText);
                                }
                            });
                    }
                })
            },

            //-- Unidades
            getUnidades() {
                let $this = this;
                $this.isLoading = true;

                axios.get(`${urlApi}/Unidade/Get`)
                    .then(res => {
                        if (res.data.success) {
                            $this.isLoading = false;
                            const result = res.data.data;

                            $this.unidades = result.rows;

                        } else {
                            avisoErro("Não foi possível carregar as unidades.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.status == 403) {
                            avisoErro("Você não tem acesso a esse produto.");
                            setTimeout(() => window.location.href = "/Home", 2000);
                        } else {
                            avisoErro(res.response?.data || res.response?.statusText || "Erro ao carregar");
                        }
                    })
                    .finally(() => {
                        $this.isLoading = false;
                    });
            },

            novoUnidade() {
                this.unidadeCrud = {
                    idUnidade: null,
                    nmUnidade: null,
                    cdUnidade: null,
                    idCliente: this.currentIdCliente,
                };
                this.showModalUnidade = !this.showModalUnidade;
            },

            editarUnidade(unidade) {
                this.unidadeCrud = {
                    idUnidade: unidade.idUnidade,
                    nmUnidade: unidade.nmUnidade,
                    cdUnidade: unidade.cdUnidade,
                    idCliente: this.currentIdCliente,
                };
                this.showModalUnidade = !this.showModalUnidade;
            },

            excluirUnidade(unidade) {
                let $this = this;
                Swal.fire({
                    title: 'Confirmar a exclusão da unidade "' + unidade.nmUnidade + '"?',
                    showDenyButton: true,
                    //showCancelButton: true,
                    confirmButtonText: 'Sim',
                    denyButtonText: 'Não',
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/Unidade/Delete/`, { idUnidade: unidade.idUnidade })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Unidade excluida com sucesso!")
                                    $this.unidade = $this.setores.filter(function (elm) { return (elm.idUnidade != unidade.idUnidade) });
                                    $this.getUnidades();
                                } else {
                                    avisoErro("Não foi possível excluir a unidade.");
                                }

                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.response.data);
                                } else {
                                    avisoErro(res.response.statusText);
                                }
                            });
                    }
                })
            },
          
        },
        mounted() {
            if (!this.isAdmOuInterno ) {
                this.$router.push({ name: 'Home' });
                return;
            }

            this.load();
        },

        watch: {
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    /* Animações */
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }

    .title-section {
        flex: 1;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 24px 0;
        }

        .header-content {
            flex-direction: column;
            text-align: center;
        }

        .modern-title {
            font-size: 28px;
        }

        .modern-subtitle {
            font-size: 13px;
        }
    }

    /* Loading Spinner */
    .loading-spinner {
        animation: fadeInUp 0.5s ease-out;

        i {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        p {
            color: #6c757d;
            font-weight: 500;
            font-size: 1.1rem;
        }
    }

    /* Tabela */
    .modern-table-card {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border-radius: 16px;
        border: 1px solid rgba(31, 123, 255, 0.12);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
        overflow: hidden;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .modern-table-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 20px 48px rgba(15, 23, 42, 0.12);
    }

    .custom-table-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1.5rem;
        padding: 1.5rem 1.75rem;
        border-bottom: 1px solid rgba(15, 23, 42, 0.06);
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(248, 250, 252, 0.85) 100%);
    }

    .header-group {
        display: flex;
        align-items: center;
        gap: 1.25rem;
    }

    .header-icon {
        width: 54px;
        height: 54px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.1) 0%, rgba(0, 208, 132, 0.1) 100%);
        color: #1f7bff;
        font-size: 1.5rem;
        box-shadow: 0 8px 18px rgba(31, 123, 255, 0.12);
    }

    .header-label {
        display: inline-flex;
        align-items: center;
        font-weight: 600;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #6b7280;
    }

    .header-title {
        margin: 0;
        font-weight: 700;
        font-size: 1.35rem;
        color: #1f2937;
        line-height: 1.2;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.5rem;
        border-radius: 12px;
        font-weight: 600;
        font-size: 0.95rem;
        border: none;
        cursor: pointer;
        transition: all 0.25s ease;
        position: relative;
        overflow: hidden;
        box-shadow: 0 10px 24px rgba(31, 123, 255, 0.25);
    }

    .modern-btn::before {
        content: '';
        position: absolute;
        inset: -60% auto auto -60%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.25);
        transform: scale(0);
        transition: transform 0.6s ease;
    }

    .modern-btn:hover::before {
        transform: scale(1);
    }

    .modern-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 18px 28px rgba(31, 123, 255, 0.35);
    }

    .modern-btn:active {
        transform: translateY(0);
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #1f7bff 0%, #0e4fd6 100%);
        color: #ffffff;
    }

    .modern-table-content {
        padding: 1.5rem 1.75rem 1.75rem;
    }

    .modern-table-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        padding: 3rem 1rem;
        border-radius: 14px;
        background: rgba(248, 250, 252, 0.9);
        color: #4b5563;
        text-align: center;
        font-weight: 500;
        animation: fadeInUp 0.4s ease;
    }

    .modern-table-state.loading i {
        font-size: 2rem;
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .modern-table-state.empty svg {
        color: #94a3b8;
    }

    .modern-table-state.empty h5 {
        margin: 0;
        font-size: 1.15rem;
        font-weight: 700;
        color: #1f2937;
    }

    .modern-table-state.empty p {
        margin: 0;
        font-size: 0.95rem;
        color: #6b7280;
    }

    .table-wrapper {
        width: 100%;
        overflow-x: auto;
        border-radius: 14px;
        border: 1px solid rgba(226, 232, 240, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
    }

    @media (max-width: 768px) {
        .table-wrapper {
            overflow-x: visible;
            border: none;
            box-shadow: none;
            border-radius: 0;
        }
    }

    .custom-table {
        width: 100%;
        border-collapse: collapse;
        min-width: 420px;
        background: #ffffff;
    }

    @media (max-width: 768px) {
        .custom-table {
            min-width: 0;
            background: transparent;
        }
    }

    .custom-table thead {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.08) 0%, rgba(0, 208, 132, 0.08) 100%);
    }

    .custom-table th {
        text-transform: uppercase;
        font-weight: 700;
        font-size: 0.75rem;
        letter-spacing: 0.08em;
        padding: 1rem 1.25rem;
        color: #4b5563;
        border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    }

    .custom-table td {
        padding: 1.1rem 1.25rem;
        font-size: 0.95rem;
        font-weight: 600;
        color: #1f2937;
        border-bottom: 1px solid rgba(226, 232, 240, 0.9);
        background: rgba(255, 255, 255, 0.85);
    }

    .custom-table tbody tr:hover {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.05) 0%, rgba(0, 208, 132, 0.05) 100%);
        transform: translateY(-1px);
        transition: all 0.2s ease;
    }

    .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

    .action-btn::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255,255,255,0.30);
        transform: translate(-50%, -50%) scale(0);
        transition: transform .6s ease;
        pointer-events: none;
    }

    .action-btn:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .action-btn svg {
        pointer-events: none;
    }

    .action-btn::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .action-btn:hover {
        transform: translateY(-1px);
        border-color: rgba(31, 123, 255, 0.4);
        box-shadow: 0 10px 22px rgba(31, 123, 255, 0.18);
    }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

    .action-btn-view:hover {
        background: linear-gradient(135deg, #059669 0%, #047857 100%);
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
    }

    .action-text {
        display: inline-block;
    }

    .action-btn-delete {
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
        padding: 0.5rem 0.9rem;
        border-radius: 10px;
        font-weight: 600;
        font-size: 0.85rem;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.25s ease;

        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

    .action-btn-delete::before {
        background: rgba(239, 68, 68, 0.1);
    }

    .action-btn-delete:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
        border-color: #ef4444;
    }

    .action-btn:active {
        transform: translateY(0);
    }

    @media (max-width: 768px) {
        .action-text {
            display: none;
        }

        .action-btn {
            padding: 12px 16px;
            min-width: 48px;
            min-height: 48px;
            flex: 1;
            justify-content: center;
            font-size: 14px;
        }

        .action-buttons {
            gap: 10px;
            flex-wrap: nowrap;
            justify-content: stretch;
            width: 100%;
        }
    }

    .setor-codigo {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        color: #2563eb;
        border-radius: 8px;
        font-weight: 700;
        font-size: 0.875rem;
        border: 2px solid #bfdbfe;
        transition: all 0.2s ease;
        font-family: 'Courier New', monospace;
    }

    .setor-codigo:hover {
        transform: scale(1.05);
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
    }

    .setor-nome {
        font-weight: 600;
        color: #1f2937;
        font-size: 0.95rem;
        transition: color 0.2s ease;
    }

    .setor-nome:hover {
        color: #2563eb;
    }

    /* Responsivo - Tablet */
    @media (max-width: 992px) {
        .custom-table-header {
            flex-wrap: wrap;
            gap: 1rem;
        }

        .header-group {
            flex: 1;
            min-width: 0;
        }
    }

    /* Responsivo - Mobile */
    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

        .modern-header .container {
            padding-left: 16px;
            padding-right: 16px;
        }

        .header-content {
            flex-direction: column;
            text-align: left;
            gap: 16px;
            padding: 0;
        }

        .modern-title {
            font-size: 24px;
        }

        .modern-subtitle {
            font-size: 13px;
        }

        .container.pt-4 {
            padding-left: 8px;
            padding-right: 8px;
        }

        .row.mb-4.px-4 {
            padding-left: 0;
            padding-right: 0;
        }

        .custom-table-header {
            flex-direction: column;
            align-items: stretch;
            padding: 1.25rem 1.4rem;
            gap: 1.25rem;
        }

        .header-group {
            width: 100%;
            flex-wrap: wrap;
            gap: 1rem;
        }

        .modern-btn {
            width: 100%;
            justify-content: center;
        }

        .modern-table-content {
            padding: 20px;
        }

        .table-wrapper {
            overflow-x: visible;
            border: none;
            box-shadow: none;
        }

        /* Transformar tabela em cards no mobile */
        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

        .custom-table thead {
            display: none;
        }

        .custom-table tbody {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .custom-table tr {
            margin-bottom: 0;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            overflow: hidden;
            border: 1px solid #e5e7eb;
            background: white;
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .custom-table td {
            text-align: left !important;
            padding: 12px 16px;
            position: relative;
            border: none;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            flex-direction: column;
            width: 100%;
            box-sizing: border-box;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }

        .custom-table td::before {
            content: attr(data-label);
            font-weight: 600;
            display: block;
            margin-bottom: 8px;
            color: #6b7280;
            font-size: 13px;
        }

        .custom-table td:last-child {
            border-bottom: none;
        }

        .action-cell {
            white-space: normal !important;
            width: 100% !important;
            padding: 16px !important;
            box-sizing: border-box;
        }

        .action-cell::before {
            margin-bottom: 12px;
        }

        .action-cell .action-buttons {
            margin-top: 0;
            width: 100%;
            box-sizing: border-box;
        }

        .setor-codigo,
        .setor-nome {
            word-wrap: break-word;
            overflow-wrap: break-word;
            max-width: 100%;
        }
    }

    /* Responsivo - Mobile Pequeno */
    @media (max-width: 576px) {
        .modern-header {
            padding: 16px 0;
        }

        .modern-header .container {
            padding-left: 12px;
            padding-right: 12px;
        }

        .modern-title {
            font-size: 20px;
        }

        .modern-subtitle {
            font-size: 12px;
        }

        .container.pt-4 {
            padding-left: 4px;
            padding-right: 4px;
        }

        .custom-table-header {
            padding: 1rem 1.2rem;
        }

        .header-icon {
            width: 48px;
            height: 48px;
            font-size: 1.3rem;
        }

        .header-title {
            font-size: 1.15rem;
        }

        .modern-table-content {
            padding: 16px;
        }

        .custom-table tr {
            margin-bottom: 0;
            border-radius: 12px;
        }

        .custom-table td {
            padding: 12px 14px;
        }

        .action-cell {
            padding: 14px !important;
        }
    }

    /* Dark Theme */
    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .modern-table-card {
        background: linear-gradient(135deg, #1a2236 0%, #111827 100%);
        border-color: rgba(59, 130, 246, 0.2);
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
        border-bottom-color: rgba(148, 163, 184, 0.15);
    }

    [data-bs-theme="dark"] .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(16, 185, 129, 0.25) 100%);
        color: #93c5fd;
        box-shadow: 0 10px 24px rgba(59, 130, 246, 0.25);
    }

    [data-bs-theme="dark"] .header-label {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .header-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 16px 32px rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .modern-table-content {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
    }

    [data-bs-theme="dark"] .modern-table-state {
        background: rgba(30, 41, 59, 0.65);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-table-state.empty svg {
        color: #475569;
    }

    [data-bs-theme="dark"] .modern-table-state.empty h5 {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .modern-table-state.empty p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .table-wrapper {
        border-color: rgba(59, 130, 246, 0.16);
        background: rgba(17, 24, 39, 0.8);
    }

    [data-bs-theme="dark"] .custom-table {
        background: transparent;
    }

    [data-bs-theme="dark"] .custom-table th {
        color: #94a3b8;
        border-bottom-color: rgba(148, 163, 184, 0.12);
    }

    [data-bs-theme="dark"] .custom-table td {
        color: #e2e8f0;
        background: rgba(30, 41, 59, 0.65);
        border-bottom-color: rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(16, 185, 129, 0.16) 100%);
    }

    [data-bs-theme="dark"] .setor-codigo {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        color: #93c5fd;
        border-color: #3b82f6;
    }

    [data-bs-theme="dark"] .setor-nome {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .setor-nome:hover {
        color: #93c5fd;
    }

    [data-bs-theme="dark"] {
        @media (max-width: 768px) {
            .custom-table tr {
                border-color: #374151;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                background: #1f2937;
            }

            .custom-table td {
                border-bottom-color: #374151;
                background: transparent;
            }

            .custom-table td::before {
                color: #9ca3af;
            }

            .custom-table td:last-child {
                background: transparent;
            }
        }
    }

    /* ========== DARK THEME ========== */
    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1a1f2e 0%, #252b3d 100%);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .modern-title {
        color: #ffffff;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .loading-spinner {
        i {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        p {
            color: #d1d5db;
        }
    }

    [data-bs-theme="dark"] .modern-table-card {
        background: linear-gradient(135deg, #1a2236 0%, #111827 100%);
        border-color: rgba(59, 130, 246, 0.2);
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
        border-bottom-color: rgba(148, 163, 184, 0.15);
    }

    [data-bs-theme="dark"] .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(16, 185, 129, 0.25) 100%);
        color: #93c5fd;
        box-shadow: 0 10px 24px rgba(59, 130, 246, 0.25);
    }

    [data-bs-theme="dark"] .header-label {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .header-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 16px 32px rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .modern-table-content {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
    }

    [data-bs-theme="dark"] .modern-table-state {
        background: rgba(30, 41, 59, 0.65);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-table-state.empty svg {
        color: #475569;
    }

    [data-bs-theme="dark"] .modern-table-state.empty h5 {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .modern-table-state.empty p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .table-wrapper {
        border-color: rgba(59, 130, 246, 0.16);
        background: rgba(17, 24, 39, 0.8);
    }

    [data-bs-theme="dark"] .custom-table {
        background: transparent;
    }

    [data-bs-theme="dark"] .custom-table th {
        color: #94a3b8;
        border-bottom-color: rgba(148, 163, 184, 0.12);
    }

    [data-bs-theme="dark"] .custom-table td {
        color: #e2e8f0;
        background: rgba(30, 41, 59, 0.65);
        border-bottom-color: rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(16, 185, 129, 0.16) 100%);
    }

    [data-bs-theme="dark"] .assinante-email {
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .assinante-login {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .badge-ativo {
        background-color: rgba(22, 163, 74, 0.25);
        color: #bbf7d0;
    }

    [data-bs-theme="dark"] .badge-inativo {
        background-color: rgba(185, 28, 28, 0.3);
        color: #fecaca;
    }

    [data-bs-theme="dark"] .action-btn-view {
        box-shadow: 0 16px 28px rgba(16, 185, 129, 0.35);
    }

    [data-bs-theme="dark"] .custom-table td::before {
        color: #9ca3af;
    }
    /* Abas */
    .tabs-row {
        display: flex;
        gap: 8px;
        margin-top: 16px;
    }

    .tab-btn {
        padding: 10px 20px;
        border: none;
        background: transparent;
        color: #6b7280;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        border-radius: 8px;
        transition: all 0.2s ease;
        position: relative;
    }

    .tab-btn:hover {
        background: rgba(37, 99, 235, 0.08);
        color: #2563eb;
    }

    .tab-btn.active {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
    }

    [data-bs-theme="dark"] .tab-btn {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .tab-btn:hover {
        background: rgba(59, 130, 246, 0.15);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .tab-btn.active {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: white;
    }
</style>

